import apiEndPoints from '../../utils/apiEndPoints'
import { apiCall } from '../../utils/httpClient';

const triggerWebhook = async (params) => {
    const data = await apiCall("post", apiEndPoints.TRIGGER_WEBHOOK, params);
    return data;
};

const updateSiteVisitStatus = async (params) => {
    const data = await apiCall("post", apiEndPoints.UPDATE_SITE_VISIT_STATUS, params);
    return data;
};

const getSiteVisitStatusData = async (params) => {
    const data = await apiCall("post", apiEndPoints.GET_SITE_VISIT_STATUS_DATA, params);
    return data;
};

const siteVisitService = {
    triggerWebhook,
    updateSiteVisitStatus,
    getSiteVisitStatusData,
};

export default siteVisitService;


